import { Box } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { ChangeHandler } from "../types";

type Props = {
  offeredAt: Date | undefined;
  handleChange: ChangeHandler;
};

export function OfferDatePicker({
  offeredAt,
  handleChange,
}: Props): JSX.Element {
  return (
    <Box style={{ width: "100%" }} mb={2}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          sx={{ width: "100%" }}
          format="MM/dd/yyyy"
          label="Offer Date"
          value={offeredAt ?? null}
          onChange={(date) => handleChange("offeredAt", date ?? undefined)}
          slotProps={{
            textField: { id: "offeredAt", margin: "normal" },
            openPickerButton: { "aria-label": "change date" },
          }}
        />
      </LocalizationProvider>
    </Box>
  );
}
